<template>
  <div class="forgot-password-page">
    <section class="form-container">
      <h1>Mot de passe oublié</h1>
       
      <form @submit.prevent="handleForgotPassword">
        <div class="form-group">
          <label for="email">Email</label>
          <input 
            type="email" 
            id="email" 
            v-model="email" 
            placeholder="Entrez votre email" 
            required 
          />
        </div>
        <button type="submit" class="btn-submit">Réinitialiser mon mot de passe</button>
        <p v-if="message" class="message">{{ message }}</p>
      </form>
      <div class="login-link">
        <p>Retour à la <router-link to="/connexion">connexion</router-link></p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ForgotPassword",
  data() {
    return {
      email: "",
      message: "",
    };
  },
  methods: {
    async handleForgotPassword() {
      if (!this.email) {
        this.message = "Veuillez entrer votre email.";
        return;
      }

      try {
        const response = await fetch('http://localhost:2028/forgotPassword', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: this.email,
          }),
        });

        const data = await response.json();

        if (response.ok) {
          this.message = data.message;
        } else {
          this.message = data.message || "Erreur lors de l'envoi de la demande.";
        }
      } catch (error) {
        this.message = "Erreur lors de la connexion au serveur.";
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
/* ====== MODE CLAIR PAR DÉFAUT ====== */
.forgot-password-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #e0f7f5, #ffffff);
  padding: 2rem;
}

.form-container {
  background: white;
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

h1 {
  margin-bottom: 1.5rem;
  color: #00998B;
  font-size: 2rem;
  font-weight: 600;
}

/* Formulaire */
form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  text-align: left;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: #555;
  font-size: 0.9rem;
  font-weight: 500;
}

input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

input:focus {
  outline: none;
  border-color: #00998B;
  box-shadow: 0 0 0 3px rgba(0, 153, 139, 0.2);
}

/* Bouton de soumission */
.btn-submit {
  width: 100%;
  padding: 0.85rem;
  background-color: #00998B;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.btn-submit:hover {
   background-color: #007c71;
  transform: translateY(-2px);
}

/* Message */
.message {
  margin-top: 1rem;
  color: #333;
  font-size: 0.9rem;
}

.message.error {
  color: #ff0000;
}

/* Lien de connexion */
.login-link {
  margin-top: 1.5rem;
  font-size: 0.9rem;
  color: #555;
}

.login-link a {
  color: #00998B;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.login-link a:hover {
  color: #00998B;
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 768px) {
  .form-container {
    padding: 1.5rem;
  }
  h1 {
    font-size: 1.75rem;
  }
}

/* ====== MODE SOMBRE AUTOMATIQUE ====== */
@media (prefers-color-scheme: dark) {
  .forgot-password-page {
    background: #121212;
  }

  .form-container {
    background: #1e1e1e;
    box-shadow: 0 4px 12px rgba(255, 255, 255, 0.05);
  }

  h1 {
    color: #078679;
  }

  label {
    color: #ccc;
  }

  input {
    background-color: #2a2a2a;
    border: 1px solid #444;
    color: #f5f5f5;
  }

  input::placeholder {
    color: #aaa;
  }

  .btn-submit {
    background-color: #078679;
  }

  .btn-submit:hover {
    background-color: #1da091;
  }

  .message {
    color: #ddd;
  }

  .message.error {
    color: #ff6b6b;
  }

  .login-link {
    color: #bbb;
  }

  .login-link a {
    color: #1da091;
  }

  .login-link a:hover {
    color: #3cd4ba;
  }
}
</style>
